export enum UploadProgressStatus {
	WAITING,
	UPLOADING,
	DONE,
	FAILED,
	CANCELLED,
	PROCESSING
}
